export default "__VITE_ASSET__ae686d86__"